export const ActivitiesColConfig = [
  {
    name_of_db_column: 'activityTitle',
    label_of_column: 'Title',
    order_of_column: 1,
    columnFilterPlaceholder: 'Title'
  },
  {
    name_of_db_column: 'customersCount',
    label_of_column: '# Customers',
    order_of_column: 2,
    columnFilterPlaceholder: '# Customers'
  },
  {
    name_of_db_column: 'percentCompleted',
    label_of_column: '% Completed',
    order_of_column: 3,
    columnFilterPlaceholder: '% Completed'
  },
  {
    name_of_db_column: 'pointsAwarded',
    label_of_column: 'Total Points Awarded',
    order_of_column: 4,
    columnFilterPlaceholder: 'Total Points Awarded'
  },
  {
    name_of_db_column: 'updatedBy',
    label_of_column: 'Updated By',
    order_of_column: 5,
    columnFilterPlaceholder: 'Updated By'
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 6,
    columnFilterPlaceholder: 'Status'
  },
  {
    name_of_db_column: 'lastUpdatedDate',
    label_of_column: 'Last Updated',
    order_of_column: 7,
    filterVariant: 'date',
    initialSize: 330,
    columnFilterPlaceholder: 'Last Updated'
  }
];
